import { useForm, ValidationError } from "@formspree/react";

export default function ContactForm() {
  const [state, handleSubmit] = useForm("xvoegnzo");
  if (state.succeeded) {
    return (
      <div
        className="alert alert-success p-5"
        role="alert"
        style={{
          color: "#75b798",
          backgroundColor: "#051b11",
          border: "5px solid #0f5132",
        }}
      >
        <h4 className="alert-heading">
          <i className="fa-solid fa-envelope-circle-check"></i>&nbsp;Sent
          successfully!
        </h4>
        <h5 className="text-center">
          Aww yeah, you successfully sent me a message. Hold tight! I'd be in
          touch pretty much very soon. Feel free to explore this website!
        </h5>
        <hr />
        <h5 className="mb-0">
          - Sunday&nbsp;<i className="fa-solid fa-face-grin-hearts"></i>
        </h5>
      </div>
    );
  }
  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          <i className="fas fa-user"></i>&nbsp;name&nbsp;
          <span className="important" title="Mandatory">
            *
          </span>
        </label>
        <input
          type="text"
          className="form-control form-control-lg"
          id="name"
          placeholder="firstname lastname"
          name="name"
          autoComplete="name"
          required
        />
        <ValidationError prefix="Name" field="name" errors={state.errors} />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 mb-3">
          <label htmlFor="email" className="form-label">
            <i className="fas fa-envelope"></i>&nbsp;email address&nbsp;
            <span className="important" title="Mandatory">
              *
            </span>
          </label>
          <input
            type="email"
            className="form-control form-control-lg"
            id="email"
            placeholder="name@domain.TLD"
            name="email"
            autoComplete="email"
            required
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>
        <div className="col-12 col-md-6 mb-3">
          <label htmlFor="phone" className="form-label">
            <i className="fas fa-mobile-screen-button"></i>
            &nbsp;phone&nbsp;
            <span className="optional" title="Optional">
              *
            </span>
          </label>
          <input
            type="tel"
            className="form-control form-control-lg"
            id="phone"
            placeholder="(***)-**-***-****"
            autoComplete="tel"
            name="phone"
          />
          <ValidationError prefix="Phone" field="phone" errors={state.errors} />
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="message" className="form-label">
          <i className="fas fa-message"></i>&nbsp;message&nbsp;
          <span className="important" title="Mandatory">
            *
          </span>
        </label>
        <textarea
          className="form-control form-control-lg"
          id="message"
          rows="5"
          name="message"
          required
        ></textarea>
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
        />
      </div>
      <div className="d-grid gap-2 mb-3">
        <button
          className="btn btn-primary btn-lg btn-submit form-control-lg"
          type="submit"
          disabled={state.submitting}
        >
          send&nbsp;<i className="fa-solid fa-paper-plane"></i>
        </button>
      </div>
    </form>
  );
}
